import mixitup from 'mixitup';

if(document.querySelector('.mixitup-container')){
  mixitup('.mixitup-container', {
    animation: {
      effects: 'fade',
      duration: 400
    },
    selectors: {
      target: '.filterable-expand-collapse',
      control: '.filter-btn'
    },
    classNames: {
      block: '',
      elementFilter: ''
    }
  });
}
